// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQs_container__2y3Rz"};